/**************************************************
 * Nombre:       Pagina
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import fondo from '../Recursos/fondo.svg'
import fondo_cell from '../Recursos/fondo_cell.svg'
import logo from '../Recursos/logo.svg'
import logo_blanco from '../Recursos/logo_blanco.svg'
import ic_abajo from '../Recursos/Iconos/ic_abajo.svg'
import Apartado_Portada from "./Apartados/Apartado_Portada";
import Apartado_Personas from "./Apartados/Apartado_Personas";
import Apartado_Razones from "./Apartados/Apartado_Razones";
import {Check} from "@mui/icons-material";
import {useResponsive} from "../Modulo_Responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import {obtenerDatoUrl} from "../Utilidades/obtenerDatoUrl";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../Servicios/BD/obtenerColWheres";
import {obtenerObjLocal} from "../Servicios/Local/obtenerObjLocal";
import {useDialogo} from "../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Fin from "./Dialogos/Dialogo_Fin";

const Pagina = () => {
    const {sCell} = useResponsive()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Fin})
    const [termino, setTermino] = useState(false)
    const [datosFunnel, setDatosFunnel] = useState({})
    const [progreso, setProgreso] = useState('')
    const [actual, setActual] = useState({})

    const obtenerFunnel = async (dato) => {

        let w = [where('titulo', '==', dato), where('estado', '==', 'Publicado')]
        let dox = await obtenerColWheres({col: 'funnels', wheres: w})

        if (dox.res && dox.data) {
            setDatosFunnel(dox.data[0])
        }
    }

    const obtenerProgreso = (dato) => {

        let prog = obtenerObjLocal({key: dato})
        if (prog) {
            setProgreso(JSON.parse(prog))
        }
    }

    const realizado = () => {
        setTermino(false)
        obtenerProgreso(datosFunnel.titulo)

    }

    useEffect(() => {

        let dato = obtenerDatoUrl({clave: 'id'})
        if (dato) {
            obtenerFunnel(dato).then(dato => {
            })

            obtenerProgreso(dato)
        }


    }, [])
    useEffect(() => {

        let obj = {}
        if (progreso && datosFunnel && datosFunnel.titulo) {




            switch (progreso.paso) {
                case 1:
                    obj.video = datosFunnel.videoUno
                    obj.titulo = datosFunnel.tituloUno
                    obj.numero = 1
                    obj.tiempo = datosFunnel.tiempoUno
                    break
                case 2:
                    obj.video = datosFunnel.videoDos
                    obj.titulo = datosFunnel.tituloDos
                    obj.numero = 2
                    obj.tiempo = datosFunnel.tiempoDos
                    break
                case 3:
                    obj.video = datosFunnel.videoTres
                    obj.titulo = datosFunnel.tituloTres
                    obj.numero = 3
                    obj.tiempo = datosFunnel.tiempoTres
                    break
                case 4:
                    abrir()
                    obj.video = datosFunnel.videoTres
                    obj.titulo = datosFunnel.tituloTres
                    obj.numero = 3
                    break
                default:
                    obj.video = datosFunnel.videoUno
                    obj.titulo = datosFunnel.tituloUno
                    obj.tiempo = datosFunnel.tiempoUno
                    obj.numero = 1
            }


        } else if (datosFunnel.titulo) {
            obj.video = datosFunnel.videoUno
            obj.titulo = datosFunnel.tituloUno
            obj.tiempo = datosFunnel.tiempoUno
            obj.numero = 1
        }

        setActual(obj)


    }, [progreso, datosFunnel])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: sCell ? `url(${fondo_cell})` : `url(${fondo})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
            }}
        >

            <Dialogo/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 10, md: 8}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4}}>
                            <img src={logo} width={sCell ? 140 : 180} height={'auto'} alt={'logo'}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Apartado_Portada termino={termino} setTermino={setTermino} actual={actual}
                                              datosFunnel={datosFunnel} realizado={realizado}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'center', mt: sCell ? 4 : 8}}>
                            <img src={ic_abajo} width={60} height={'auto'} alt={'logo'}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'center', mt: sCell ? 4 : 8}}>
                            <Apartado_Personas/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? 8 : 14}}>
                            <Apartado_Razones/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'center', mt: 6}}>
                            <Typography sx={{fontWeight: 400, textAlign: 'center', lineHeight: 1.1, fontSize: 14}}>
                                Termina este video antes de continuar con el siguiente, esto te dara mejore resultados
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                            <Button
                                startIcon={<Check/>}
                                disabled={!termino}
                                sx={{
                                    background: !termino ? "#00000080" : 'linear-gradient(90deg, #9049F5 0%, #7A1CFF 51.44%, #39E8FF 100%)',
                                    fontWeight: 500,
                                    px: 4,
                                    py: 1.5
                                }}
                            >
                                {termino ? 'Continuar' : `Termina el video de ${actual.tiempo} Min`}

                            </Button>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    background: 'linear-gradient(180deg, #9049F5 0%, #7A1CFF 50%, #2D8F9D 100%)',
                    p: 2,
                    mt: 6
                }}
            >

                <img src={logo_blanco} width={150} height={'auto'} alt={'logo'}/>

            </Grid>

        </Grid>
    )

}
export default Pagina  